<template>
	<!-- まとめ買い数量分を一気にカートに入れるボタンを追加 -->
	<div class="matomeAddCart sort-item" v-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp) && ptInitData.productInfo && !common.isNullItem(ptInitData.productInfo.BUTTON_NM)
		&& ((ptInitData.loginKbn && ptInitData.productInfo.NEED_MEMBER_FLG == 1) || ptInitData.productInfo.NEED_MEMBER_FLG == 0)
		&& ptInitData.productInfo.MATOME_ITEM_KBN == '0'">
		<button class="matomeBtn" @click="pt125doOrder(3)">
			<span v-html="ptInitData.productInfo.BUTTON_NM"></span>
		</button>
	</div>
</template>
<script>
import common from "assets/js/common";
	export default {
		name: 'matomeAddCart',
		props: {
			ptInitData: {
				type: Object,
				default: null
			},
			isLp: {
				type: Boolean,
				default: false
			}
		},
		data: function() {
			return {
				common
			}
		},
		methods: {
			pt125doOrder: function (e) {
				this.$emit('pt125doOrder', e);
			}
		}
	}
</script>